// Lib
import React, { ReactElement } from 'react';

// Utils
import { prop } from '../../../../../common/utils/immutableHelper';

// Hooks
import useClosePopupOnUnmount from '../../../../components/popupPanel/useClosePopupOnUnmount';
import { useGroupTranslator } from '../../../../components/i18n/GroupTranslationContext';

// Components
import ToolbarTool from '../../../../workspace/toolbar/components/ToolbarTool';
import ToolbarPopup from '../../../../workspace/toolbar/components/toolbarPopup/ToolbarPopup';
import PopupTrigger from '../../../../components/popupPanel/PopupTrigger';
import TableTextStylePopupContent from './TableTextStylePopupContent';

// Constants
import { PopupIds } from '../../../../components/popupPanel/popupConstants';

// Types
import { ToolbarToolProps } from '../../../../workspace/toolbar/config/toolDefinitions/toolbarToolTypes';

// Styles
import '../../../../workspace/toolbar/components/selectionTools/editorTools/TextStyleTool.scss';

type TableTextStyleToolButtonProps = {
    isPopupOpen: boolean;
    name?: string;
};

/**
 * Renders the table text style toolbar button.
 */
const TableTextStyleToolButton: React.FC<TableTextStyleToolButtonProps> = ({ isPopupOpen, name }) => {
    return (
        <ToolbarTool className="TableTextStyleToolButton" isOpen={isPopupOpen} name={name || 'Text style'}>
            {/* using a div with a .png image here instead of a svg Icon
            because the gradient does not export correctly */}
            <div className="text-style-icon" />
        </ToolbarTool>
    );
};

/**
 * Renders text style controls for selected table cells.
 */
const TableTextStyleTool: React.FC<ToolbarToolProps> = (props): ReactElement => {
    const { uid, id, selectedElements } = props;

    const element = prop(0, selectedElements);

    const translate = useGroupTranslator();
    const name = translate('tools.editing.textStyle') as string;

    const popupId = uid || id || PopupIds.BLOCK_STYLE;

    // Close the popup when the component unmounts to prevent it from being left open
    //  and appearing the next time the tool shows
    useClosePopupOnUnmount(popupId);

    return (
        <div className="TableTextStyleTool">
            <PopupTrigger popupId={popupId} preventFocus>
                {(popupIsOpen) => <TableTextStyleToolButton isPopupOpen={popupIsOpen} name={name} />}
            </PopupTrigger>
            <ToolbarPopup popupId={popupId} buttonSelector=".TableTextStyleToolButton .icon" className="TextStylePopup">
                <TableTextStylePopupContent element={element} />
            </ToolbarPopup>
        </div>
    );
};

export default TableTextStyleTool;
